import React, { useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Typography,
  makeStyles,
  Card,
  CardContent,
  CardActions,
  IconButton,
  TextField,
  Select,
  FormControl,
  InputLabel,
  Grid,
} from "@material-ui/core";
import {
  Folder as FolderIcon,
  DeleteForever as DeleteIcon,
} from "@material-ui/icons";
import { red } from "@material-ui/core/colors";
import {
  clear,
  selectRequestproduct,
  getListofRequestproduct,
  updateList,
  removefromlist,
  set,
} from "./requestproductSlice";
import styles from "./Requestproduct.module.css";
import { selectLanguage } from "../language/languageSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "80%",
    minWidth: 150,
    margin: "auto",
    // minHeight: 331,
    boxShadow: "0 1px 1.5px rgba(0,0,0,0.16), 0 1px 1.5px rgba(0,0,0,0.23)",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    minWidth: "100%",
  },
  prdlv2: {
    paddingLeft: "4vw",
  },
  prdlv3: {
    paddingLeft: "8vw",
  },
  prdlv4: {
    paddingLeft: "16vw",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 24,
  },
  productname: {
    fontSize: 18,
  },
  pos: {
    marginBottom: 12,
  },
  amount: {
    fontSize: 14,
  },
  minReq: {
    color: red[500],
    fontSize: 14,
  },
  hidden: {
    visibility: "hidden",
  },
}));

export function RequestProduct() {
  const classes = useStyles();
  const currentRequestProduct = useSelector(selectRequestproduct);
  const listOfRequestProduct = useSelector(getListofRequestproduct);
  const language = useSelector(selectLanguage);
  const dispatch = useDispatch();
  const unitText = language === "TH" ? "หน่วย" : "unit";
  let Header = [];
  if (listOfRequestProduct.length > 0) {
    Header.push(
      <Typography className={classes.title}>
        {language === "TH" ? "ผลิตภัณฑ์ที่สนใจ" : "Interested Product"}
      </Typography>
    );
  }
  return (
    <React.Fragment>
      {Header}
      <Grid container spacing={3}>
        {listOfRequestProduct.map((Prd) => {
          return (
            <Grid item xs={12} sm={6} md={4}>
              <Card className={classes.root} variant="outlined">
                <CardContent>
                  <Typography
                    className={classes.productname}
                    color="textSecondary"
                    gutterBottom
                  >
                    {Prd.Name}
                  </Typography>
                  <Typography
                    className={classes.amount}
                    color="textSecondary"
                    gutterBottom
                  >
                    {language === "TH" ? "จำนวน" : "Amount"}
                  </Typography>
                  <TextField
                    type="number"
                    value={Prd.CurrentVol}
                    onChange={(e) => {
                      let tmpPrd = JSON.parse(JSON.stringify(Prd));
                      if (e.target.value === "") tmpPrd.CurrentVol = 0;
                      else {
                        let valueInt = parseInt(e.target.value);
                        if (valueInt >= 1000000) {
                          valueInt = 1000000;
                        }
                        tmpPrd.CurrentVol = valueInt.toString();
                      }

                      dispatch(updateList(tmpPrd));
                    }}
                  />
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="unit-native-simple">
                      {unitText}
                    </InputLabel>
                    <Select
                      native
                      value={Prd.CurrentUnit}
                      onChange={(e) => {
                        let tmpPrd = JSON.parse(JSON.stringify(Prd));
                        tmpPrd.CurrentUnit = e.target.value;
                        dispatch(updateList(tmpPrd));
                      }}
                      className={classes.selectEmpty}
                      inputProps={{
                        name: "unit",
                        id: "unit-native-simple",
                      }}
                    >
                      {Prd.Unit.map((unit) => {
                        return <option value={unit.id}>{unit.Name}</option>;
                      })}
                    </Select>
                  </FormControl>
                  <Typography
                    className={
                      Prd.minQty !== null ? classes.minReq : classes.hidden
                    }
                    gutterBottom
                  >
                    {language === "TH"
                      ? "*จำนวนขั้นต่ำ ".concat(Prd.minQty)
                      : "*Minimum Quantity ".concat(Prd.minQty)}
                  </Typography>
                </CardContent>
                <CardActions>
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={() => {
                      //console.log(Prd.id);
                      dispatch(
                        removefromlist(
                          listOfRequestProduct.filter(
                            (listPrd) => listPrd.id !== Prd.id
                          )
                        )
                      );
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </CardActions>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </React.Fragment>
  );
}
